import { Box } from '@mui/material';
import * as React from 'react';
import SelectBox from './SelectBox';

export default function TableSelBox(props) {
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    setOptions(props.options);
  }, [props.options]);

  return (
    <Box
      style={{
        margin: 'auto',
        width: '100%',
        fontSize: 20,
        display: 'grid',
        gridTemplateColumns: '100%',
      }}>
      {options ? (
        <>
          <SelectBox
            items={options}
            value={props.value}
            setValue={props.setValue}
            type={props.type}
            edit={props.edit}
          />
        </>
      ) : (
        <></>
      )}
    </Box>
  );
}
